import { useMutation, useQuery, useQueryClient } from 'react-query';
import { request } from '../utils/axios-utils';

const selectData = response => response?.data?.data;

export function useRateCardList() {
    return useQuery(['revenue', 'rate-cards'], () => request({ url: '/revenue/rate-cards', method: 'GET' }), {
        refetchOnWindowFocus: false,
        select: selectData,
    });
}

export function useRateCardVersions(companyCode) {
    return useQuery(
        ['revenue', 'rate-card-versions', companyCode],
        () => request({ url: `/revenue/rate-cards/${encodeURIComponent(companyCode)}/versions`, method: 'GET' }),
        { enabled: !!companyCode, refetchOnWindowFocus: false, select: selectData }
    );
}

export function useMatcherFields(companyCode) {
    return useQuery(
        ['revenue', 'matcher-fields', companyCode],
        () => request({ url: '/revenue/matcher-fields', method: 'GET', params: { companyCode } }),
        { enabled: !!companyCode, refetchOnWindowFocus: false, select: selectData }
    );
}

export function useSaveRateCard(companyCode) {
    const queryClient = useQueryClient();
    return useMutation(
        body => request({ url: `/revenue/rate-cards/${encodeURIComponent(companyCode)}/versions`, method: 'POST', data: body }),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['revenue', 'rate-cards']);
                queryClient.invalidateQueries(['revenue', 'rate-card-versions', companyCode]);
            },
        }
    );
}

export function useDeleteRateCard(companyCode) {
    const queryClient = useQueryClient();
    return useMutation(
        id => request({ url: `/revenue/rate-cards/${encodeURIComponent(companyCode)}/versions/${id}`, method: 'DELETE' }),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['revenue', 'rate-cards']);
                queryClient.invalidateQueries(['revenue', 'rate-card-versions', companyCode]);
            },
        }
    );
}

export function usePreviewRateCard(companyCode) {
    return useMutation(body =>
        request({ url: `/revenue/rate-cards/${encodeURIComponent(companyCode)}/preview`, method: 'POST', data: body })
    );
}
